import React from 'react';
import PropTypes from 'prop-types';
import { EMPTINESS_SIGN } from 'rp-react-table';
import { isRunnerCode } from './helper';

const getValue = (value, zeroToDash) => {
    if (value || (!zeroToDash && value === 0)) {
        return value;
    }
    return EMPTINESS_SIGN;
};

const NonRunnerSwitcherTableCell = ({ code, value, zeroToDash }) => (
    <span>
        {isRunnerCode(code)
            ? <span>{getValue(value, zeroToDash)}</span>
            : EMPTINESS_SIGN
        }
    </span>
);

NonRunnerSwitcherTableCell.propTypes = {
    code: PropTypes.string,
    zeroToDash: PropTypes.bool,
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
};

export default NonRunnerSwitcherTableCell;



// WEBPACK FOOTER //
// ./src/js/horse/form/formTable/NonRunnerSwitcherTableCell.jsx